import API from "services";
import { useQuery } from "react-query";

export const useGetPmaxURLExclusions = () =>
  useQuery(["url-exclusions"], API.services.adLibrary.getURLExclusions);
